module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_16-504b08b7a67950bab555d9c5aecbeaa2.jpg";